import Footer from "~/components/common/Footer";
import PageContainer from "~/components/common/PageContainer";
import { Card, CardHeader, CardTitle } from "~/components/ui/card";

interface TextLayoutProps {
  title: string;
  htmlContent: string;
}

export default function TextLayout({ title, htmlContent }: TextLayoutProps) {
  return (
    <PageContainer>
      <div className="container mx-auto p-3">
        <Card className="gap-2 p-4">
          <CardHeader className="p-0">
            <CardTitle className="text-lg font-bold">{title}</CardTitle>
          </CardHeader>
          <div className="max-w-full text-base text-gray-700" dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </Card>
      </div>
      <Footer />
    </PageContainer>
  );
}
